<template>
  <div
    v-if="showFullPreview"
    id="fileFullPreview"
    ref="filePreview"
    class="file-full-preview-wrapper"
    tabindex="-1"
    @click="closeContextMenu"
    @keydown.esc=";((showFullPreview = false), hideContextMenu())"
    @keydown.right="next"
    @keydown.left="prev"
  >
    <FilePreviewNavigationPanel></FilePreviewNavigationPanel>
    <MediaFullPreview :key="previewKey"></MediaFullPreview>
    <FilePreviewActions></FilePreviewActions>
  </div>
</template>

<script>
import { events } from '@main/js/bus'
import { mapGetters } from 'vuex'

import MediaFullPreview from '@assets/js/components/MediaFullPreview'
import FilePreviewActions from '@assets/js/components/FilePreviewActions'
import FilePreviewNavigationPanel from '@assets/js/components/Preview/FilePreviewNavigationPanel'

export default {
  name: 'FileFullPreviewMode',
  components: {
    MediaFullPreview,
    FilePreviewNavigationPanel,
    FilePreviewActions,
  },
  data() {
    return {
      showFullPreview: false,
      previewKey: 0,
    }
  },
  computed: {
    ...mapGetters(['fileInfoDetail', 'dataPreview']),
  },
  updated() {
    //Focus file preview for key binding
    if (this.showFullPreview) {
      this.$refs.filePreview.focus()
    }
  },
  mounted() {
    events.$on('fileFullPreviewMode:show', (item) => {
      // Fully hide and reset before showing a new preview to avoid stale flash
      this.showFullPreview = false
      this.previewKey = 0
      try { this.$store.commit('CLEAR_FILEINFO_DETAIL') } catch (e) {}

      this.$nextTick(() => {
        // Ensure a selected file before mount
        try {
          if (item) {
            if (this.$store.getters.dataPreview && this.$store.getters.dataPreview.length) {
              this.$store.commit('GET_FILEINFO_DETAIL_PREVIEW', item)
            } else {
              this.$store.commit('LOAD_FILEINFO_DETAIL', item)
            }
          }
        } catch (e) {}

        // Mount fresh instance keyed by the selected file
        const k = (item && item.unique_id) || Date.now()
        this.previewKey = k
        this.showFullPreview = true
      })
    })
    events.$on('fileFullPreviewMode:hide', () => {
      this.showFullPreview = false
      this.previewKey = 0
      // Clear selection to prevent stale render on next open
      try { this.$store.commit('CLEAR_FILEINFO_DETAIL') } catch (e) {}
      /*events.$emit('hide:mobile-navigation')*/
    })
  },
  methods: {
    closeContextMenu(event) {
      if (
        (event.target.parentElement.id || event.target.id) ===
        'fast-preview-menu'
      ) {
        return
      } else {
        events.$emit('showContextMenuPreview:hide')
      }
    },
    next: function () {
      events.$emit('filePreviewAction:next')
    },
    prev: function () {
      events.$emit('filePreviewAction:prev')
    },
    hideContextMenu() {
      events.$emit('showContextMenuPreview:hide')
    },
  },
}
</script>

<style lang="scss" scoped>
.file-full-preview-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.14);
}
</style>
